const auth = {
  auth: {
    login: {
      title: "Administration",
      subtitle: "Sign in to manage your portfolio",
      emailLabel: "Email Address",
      passwordLabel: "Password",
      submit: "Sign in",
      errorFallback: "Login error",
    },
    forgotPassword: {
      button: "Forgot password?",
      title: "Reset password",
      subtitle: "Enter your email address to receive a reset link.",
      emailLabel: "Email Address",
      send: "Send reset link",
      backToLogin: "Back to login",
      success: "If an account exists for this email, a reset link has been sent.",
      error: "Error sending the reset link",
    },
  },
};

export default auth;
